<template>
<div class="container p-30">
  <Logo class="mb-30" />
  <div class="mb-20" v-if="!connect_method">Select one of the following options:</div>
  <div class="mb-20" v-if="connect_method === 1">Sign up for FREE Internet:</div>
  <div class="mb-20">
    <button v-show="!connect_method" @click="handleClickMethod(1)">Hotel Guest</button>
    <div class="connect-method-form" v-show="connect_method === 1">
      <div class="mb-20"><input v-model="form.last_name" type="text" placeholder="Last Name" /></div>
      <div class="mb-20"><input v-model="form.room_number" type="text" placeholder="Room Number" /></div>
      <div class="mb-20"><input v-model="form.email_address" type="text" placeholder="Email Address" /></div>
      <div class="checkbox-container"><label><input v-model="form.upgrade" type="checkbox" /> I WANT IT EXTRA FAST - Upgrade to premium wifi for $19.95</label></div>
      <div class="pt-20">
        <button class="mb-20" :disabled="disabled || !show_continue" @click="handleClickConnect()">Connect!</button>
        <TermsOfService>
          <button :disabled="disabled || !show_continue" @click="handleClickConnect()">Connect!</button>
        </TermsOfService>
      </div>
      <a href="#" class="d-block pt-20" @click.prevent="handleClickMethod()">Take me back, I'm actually a Visitor...</a>
    </div>
  </div>
  <div class="mb-20">
    <button v-show="!connect_method" @click="handleClickMethod(2)">Visitor</button>
    <div class="connect-method-form" v-show="connect_method === 2">
      <div class="mb-20"><input v-model="form.access_code" type="text" placeholder="Access Code" /></div>
      <div><input v-model="form.email_address" type="text" placeholder="Email Address" /></div>
      <div class="pt-20">
        <button class="mb-20" :disabled="disabled || !show_continue" @click="handleClickConnect()">Connect!</button>
        <TermsOfService>
          <button :disabled="disabled || !show_continue" @click="handleClickConnect()">Connect!</button>
        </TermsOfService>
      </div>
      <a href="#" class="d-block pt-20" @click.prevent="handleClickMethod()">Take me back, I'm actually a Hotel Guest...</a>
    </div>
  </div>
  <SupportAndDeviceInfo :phone="portal.template.support_phone" :ip="connection_data.client_ip" :mac="connection_data.client_mac" />
</div>
</template>

<script>
import Logo from '@/components/custom/standardHotels/Logo'
import TermsOfService from '@/utilities/TermsOfService'
import SupportAndDeviceInfo from '@/utilities/SupportAndDeviceInfo'

export default {
  name: 'custom_template',
  props: [ 'template', 'portal', 'connection_data' ],
  components: { Logo, TermsOfService, SupportAndDeviceInfo },
  computed: {
    show_continue:function(){
      if(this.connect_method === 1) return this.form.last_name && this.form.room_number && this.form.email_address;
      if(this.connect_method === 2) return this.form.access_code && this.form.email_address;
    },
  },
  data(){
    return{
      disabled: true,
      connect_method: null,
      form: {
        upgrade: false,
        access_code: null,
        room_number: null,
        first_name: null,
        last_name: null,
        email_address: null,
      },
    }
  },
  watch: {
    'form': {
      deep: true,
      handler(){ this.disabled = false }
    }
  },
  created(){
    document.documentElement.classList.add('standardHotels');
  },
  methods: {
    handleClickMethod(method=null){
      this.disabled = false;
      this.connect_method = method;
    },
    setRegistrationData(){
      if(this.connect_method === 1){
        // Required: Last Name & Room registration method with 2 Rateplans: 1 free, 1 premium
        const registration_method = this.portal.registration_methods.find(registration_method => registration_method.registration_method_id === 2);
        const free_rate_plan = registration_method.rate_plans.find(rateplan => rateplan.price === '0.00');
        const premium_rate_plan = registration_method.rate_plans.find(rateplan => rateplan.price !== '0.00');
        const rateplan_id = this.form.upgrade ? premium_rate_plan.rateplan_id : free_rate_plan.rateplan_id;
        return {
          registration_method_id: registration_method.registration_method_id,
          rateplan_id: rateplan_id,
          last_name: this.form.last_name,
          room_number: this.form.room_number,
          email_address: this.form.email_address
        }
      } else if(this.connect_method === 2) {
        return {
          registration_method_id: 4,
          access_code: this.form.access_code,
          email_address: this.form.email_address
        }
      }
    },
    handleClickConnect: function(){
      this.disabled = true;
      this.$emit('emitRegistrationMethodData', this.setRegistrationData() );
    },
  }
}
</script>
<style>
@font-face { font-family: 'TradeGothic'; font-weight: normal; src: url('assets/trade-gothic-condensed-18.woff'); }
@font-face { font-family: 'TradeGothic'; font-weight: bold; src: url('assets/trade-gothic-condensed-20.woff'); }
.standardHotels { overflow-y: scroll; background: #fff; font-size: 20px;  }
.standardHotels #app, .standardHotels button, .standardHotels input[type="text"] { font-family: 'TradeGothic', Helvetica, sans-serif; color: #6B6B6B; }
.standardHotels button { border: 2px solid #fff; cursor: pointer; line-height: 1; background: #ee2324; color: #ffffff; width: 100%; font-weight: bold; padding: 14px 0 10px; font-size: 32px;  }
.standardHotels button[disabled] { cursor: not-allowed; }
.standardHotels button:not([disabled]):hover { border-color: #ee2324; box-shadow: 0.25rem 0.25rem 0 #ee2324; background: #fff; color: #ee2324;  }
.standardHotels input[type="text"] { padding: 20px 22px; font-size: 20px; border: 1px solid #ddd; width: 100%;}
.standardHotels .checkbox-container { font-size: 16px; display: flex; align-items: center; }
.standardHotels .d-block { display: block; }
.standardHotels a { color: #6B6B6B; }
.standardHotels a:hover { color: #1a1a1a; }
</style>
